__turbopack_context__.v({
  "brands-alphabet": "styles-module-scss-module__DLwWhW__brands-alphabet",
  "brands-alphabet__item": "styles-module-scss-module__DLwWhW__brands-alphabet__item",
  "brands-alphabet__item--active": "styles-module-scss-module__DLwWhW__brands-alphabet__item--active",
});
